import Vue from 'vue'
import lightTip from './index.vue'
// 创建组件构造器
const lightTipHonor = Vue.extend(lightTip);

export default function ({ msg = "", type = undefined } = {}) {
    return new Promise((reslove, reject) => {
        let lightTipComponent = new lightTipHonor({ el: document.createElement('div') });
        lightTipComponent.msg = msg;
        lightTipComponent.type = type;

        //插入到body
        document.body.appendChild(lightTipComponent.$el)
        // 回调函数
        lightTipComponent.close = function () {
            console.log(111)
            reslove();
        };
    })
}